import { Route, Routes } from 'react-router-dom';
import { useEffect } from 'react';
import DashboardPage from './pages/DashboardPage';
import NotFoundPage from './pages/NotFoundPage';
import { PaymentPage } from './pages/PaymentPage';
import AdminPage from './pages/AdminPage';
import UserCardPage from './pages/UserCardPage';
import MyCardPage from './pages/MyCardPage';
import NewsPage from './pages/NewsPage';
import RafflePage from './pages/RafflePage';
import RaffleGeneratorPage from './pages/RaffleGeneratorPage';
import MerchantPage from './pages/MerchantPage';
import MerchantTestPage from './pages/MerchantTestPage';
import CheckoutPage from './pages/CheckoutPage';
import AdminMerchantsPage from './pages/AdminMerchantsPage';
import { useSession } from './state/SessionContext';
import AppLayout from './components/AppLayout';
import LoadingScreen from './components/LoadingScreen';

const LOGOUT_REDIRECT_PATH = '/en/login';

function RedirectToClassicLogin() {
  useEffect(() => {
    window.location.assign(LOGOUT_REDIRECT_PATH);
  }, []);

  return null;
}

function App() {
  const { status } = useSession();

  if (status === 'initializing') {
    return <LoadingScreen message="Checking session…" />;
  }

  return (
    <Routes>
      <Route
        path="/"
        element={
          status === 'authenticated' ? <AppLayout /> : <RedirectToClassicLogin />
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="my-card" element={<MyCardPage />} />
        <Route path="raffle" element={<RafflePage />} />
        <Route path="admin" element={<AdminPage />} />
        <Route path="admin/merchants" element={<AdminMerchantsPage />} />
        <Route path="merchant" element={<MerchantPage />} />
        <Route path="merchant/test" element={<MerchantTestPage />} />
      </Route>
      <Route path="/checkout/:orderId" element={<CheckoutPage />} />
      <Route path="/pay/:orderId" element={<PaymentPage />} />
      <Route path="/pay/:userId/:method" element={<UserCardPage />} />
      <Route path="/card/:userId" element={<UserCardPage />} />
      <Route path="/card/:userId/:method" element={<UserCardPage />} />
      <Route path="/news" element={<NewsPage />} />
      <Route path="/raffle" element={<RaffleGeneratorPage />} />
      <Route path="/raffle-generator" element={<RaffleGeneratorPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
